import {
  SUPERSET_VERTICALLY_CSAT,
  SUPERSET_VERTICALLY_CSAT_SUCCESS,
  SUPERSET_VERTICALLY_CSAT_ERROR,
  SUPERSET_VERTICALLY_CSAT_EMPTY,
} from '../../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const SupersetVerticallyCSAT = (state = initialState, action) => {
  switch (action.type) {
    case SUPERSET_VERTICALLY_CSAT:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SUPERSET_VERTICALLY_CSAT_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case SUPERSET_VERTICALLY_CSAT_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SUPERSET_VERTICALLY_CSAT_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SupersetVerticallyCSAT;
